import React, {ReactNode, useState} from 'react';
import {IMapFeaturesContext} from "./types";
import {MapFeatures} from "@ui/leafletCustom/types";


export const MapFeaturesContext = React.createContext<IMapFeaturesContext | null>(null)

interface IProps {
    mapFeatures?: MapFeatures,
    children?: ReactNode
}

const MapFeaturesContextProvider = ({children}: IProps) => {

    const [mapFeatures, setMapFeatures] = useState<MapFeatures>()


    return (
        <MapFeaturesContext.Provider
            value={{
                mapFeatures,
                setMapFeatures,
            }}
        >
            {children}
        </MapFeaturesContext.Provider>
    );
};

export default MapFeaturesContextProvider;